import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionContextStoreService {
  hostName = window.location.hostname.split('.')[0];

  setSessionContext(context: string, userName, usedStatus: 'true' | 'false') {
    localStorage.setItem(`${userName}_${this.hostName}_context`, context);
    this.setUsedStatus(userName, usedStatus);
  }

  setUsedStatus(username, usedStatus) {
    localStorage.setItem(
      `${username}_${this.hostName}_context_used`,
      usedStatus,
    );
  }

  // Getter hasn't been defined here. It's directly being used in sidebar component.
}
